import { SimulationRendererService } from './../../services/simulation-renderer.service';
import { SimulationState } from '../../enums/simulation-state';
import { Component } from '@angular/core';
import { SimulationService } from '../../services/simulation.service';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state/user/user.state';
import { FeaturesState } from 'src/app/state/features/features.state';

@Component({
  selector: 'app-simulation-details',
  templateUrl: './simulation-details.component.html'
})
export class SimulationDetailsComponent {

  @Select(UserState.debuggerAccess) debuggerAccess$!: Observable<boolean>;
  @Select(FeaturesState.simulationDetailsEnabled) simulationDetailsEnabled$!: Observable<boolean>;
  public SimulationState = SimulationState;
  constructor(public simulationService: SimulationService, public renderService: SimulationRendererService) {

  }

  public getSimulationTime(): string | null {
    if (this.simulationService.simulationState !== SimulationState.Completed) {
      return '';
    }
    if (this.renderService.runDetails?.simulationStartedOn && this.renderService.runDetails?.simulationEndedOn) {
      return this.formatTime(this.renderService.runDetails.simulationEndedOn - this.renderService.runDetails.simulationStartedOn);
    }
    return null;
  }

  formatTime(timeInMs: number): string {
    const msInSecond: number = 1000;
    const msInMinute: number = 60000;
    const msInHour: number = 3600000;

    if (timeInMs < msInSecond) {
      return `${Math.floor(timeInMs)} ms`;
    }

    const seconds: number = Math.floor((timeInMs % msInMinute) / msInSecond);
    const minutes: number = Math.floor((timeInMs % msInHour) / msInMinute);
    const hours: number = Math.floor(timeInMs / msInHour);

    if (timeInMs < msInMinute) {
      return `${Math.floor(timeInMs / msInSecond)} s`;
    }

    if (timeInMs < msInHour) {
      return `${minutes} min ${seconds} s`;
    }

    return `${hours} h ${minutes} min ${seconds} s`;
  }
}
